export default __webpack_public_path__ + "media/images/svg/hero_down_arrow-b2c0dfbe2ec05ff7b1c3f40643e1476f.svg";